import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

export default function DashboardPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <main className="auth-page">
      <div className="auth-card auth-card--dashboard">
        <h1>Dashboard</h1>
        <p className="auth-subtitle">Sikeresen be vagy jelentkezve.</p>

        <div className="dashboard-user-meta">
          <p>
            <strong>Név:</strong> {user?.username || '-'}
          </p>
          <p>
            <strong>Email:</strong> {user?.email || '-'}
          </p>
          <p>
            <strong>Szerepkör:</strong> {user?.role || 'user'}
          </p>
        </div>

        <div className="dashboard-actions">
          <Link className="auth-submit-btn" to="/">
            Vissza a főoldalra
          </Link>
          {user?.role === 'admin' && (
            <Link className="auth-google-btn" to="/blpkmap">
              Admin panel megnyitása
            </Link>
          )}
          <button type="button" className="auth-google-btn" onClick={handleLogout}>
            Kijelentkezés
          </button>
        </div>
      </div>
    </main>
  );
}
